import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'
import { Ripple } from 'vuetify/lib/directives';
Vue.use(Vuetify, {
    directives: {
      Ripple
    }
  });

// const mq = window.matchMedia('(prefers-color-scheme: dark)')

export default new Vuetify({
    rtl: false,
    theme: { 
        dark: false,
        themes: {
            light: {
              // primary: "#ff8e00",
              primary: colors.grey.darken3,
              secondary: colors.grey.lighten3,
              accent: colors.grey.darken4,
              background: colors.grey.lighten5,
              surface: colors.grey.lighten5,
              error: colors.red.darken1,
              success: colors.green.darken1,
              disabled: colors.grey.lighten3,
              white: "#FFFFFF",
              black: "#000000",
          },
          dark: {
            primary: colors.grey.darken2,
            secondary: colors.grey.darken4,
            white: colors.grey.darken4,
          }
        }
    },
    icons: {
      iconfont: 'mdi',
    },
})

// mq.addEventListener('change', (e) => {
//   vuetify.framework.theme.dark = e.matches
// });

// export default new Vuetify({
//   icons: {
//     iconfont: 'mdi',
//   },
// });
